var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 145.25 147.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web",
    transform: "translate(-2.04 -2.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M74.659,43.279q19.14,0,38.278,0c2.263,0,3.275,1.025,3.275,3.263q-.006,24.41,0,48.818c0,2.365-.986,3.351-3.361,3.351q-17.065,0-34.133,0c-1.223,0-1.223,0-1.225,1.229,0,3.832.018,7.664-.014,11.494-.006.742.2,1.013.973,1,2.42-.043,4.84-.016,7.26-.016a2.684,2.684,0,0,1,2.609,1.652c.449.953.266,1.23-.781,1.23q-6.654.009-13.307.006-6.219,0-12.443-.006c-1.043,0-1.227-.281-.777-1.234a2.7,2.7,0,0,1,2.613-1.651c2.42,0,4.84-.031,7.26.017.775.015.973-.242.967-.99q-.049-5.874,0-11.752c.006-.739-.188-.992-.967-.991q-17.238.033-34.477.016c-2.253,0-3.287-1.007-3.287-3.249q-.008-24.539-.006-49.081a2.794,2.794,0,0,1,3.09-3.109q19.224,0,38.451,0S74.659,43.277,74.659,43.279ZM74.6,93.061q18.841,0,37.678.01c.661,0,1.061-.043,1.059-.9q-.033-22.554-.006-45.11c0-.666-.183-.982-.881-.892a4.682,4.682,0,0,1-.6,0h-74.5c-1.343,0-1.347,0-1.346,1.372q0,22.167,0,44.335c0,1.188,0,1.188,1.172,1.188Q55.894,93.059,74.6,93.061Z",
    fill: "#0073E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M82.573,84.511a.566.566,0,0,1-.509-.266c-1.625-1.666-1.614-1.806.22-3.188,4.25-3.209,8.489-6.435,12.762-9.618.66-.491.617-.729.033-1.262-4.642-4.225-9.24-8.494-13.877-12.723-.591-.538-.617-.863-.031-1.423,1.41-1.347,1.371-1.361,2.824-.029q7.861,7.2,15.739,14.4c.8.731.783.744-.053,1.37q-8.238,6.148-16.474,12.3C82.979,84.234,82.743,84.393,82.573,84.511Z",
    fill: "#0073E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M65.913,56.673c-.018.334-.256.479-.439.648q-4.8,4.417-9.6,8.828c-1.484,1.363-2.959,2.737-4.471,4.072-.525.466-.537.725.051,1.164,4.566,3.415,9.1,6.873,13.668,10.283.65.484.764.821.234,1.488-1.189,1.5-1.16,1.531-2.682.4Q54.736,77.645,46.8,71.742c-.646-.477-.654-.761-.068-1.295Q55.044,62.9,63.311,55.294c.561-.517.938-.508,1.4.068A14.95,14.95,0,0,1,65.913,56.673Z",
    fill: "#0073E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M78.7,56.633c-.412,1.408-.816,2.819-1.236,4.225Q74.18,71.815,70.89,82.772c-.381,1.268-.373,1.278-1.631.891-1.654-.514-1.705-.1-1.1-2.133Q71.926,69,75.669,56.47c.343-1.147.336-1.153,1.472-.818.387.113.77.238,1.155.354C78.607,56.1,78.827,56.253,78.7,56.633Z",
    fill: "#0073E6"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 71.625,
    cy: 72.719,
    rx: 71.625,
    ry: 72.719,
    transform: "translate(3.04 3.163)",
    fill: "none",
    stroke: "#0073E6",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.4fe6cfd3521a746ca8f0153e22f4a976.svg";
export { ForwardRef as ReactComponent };